import React from 'react';
import { StyleSheet, View } from 'react-native';

import themeStyle from '../Theme/styles';

import { RectangleLoader } from './Loader';

type Props = {
  contentContainerStyle?: any;
  leftSize?: number;
  rightSize?: number;
  spacing?: number;
  textSize?: number;
  withLeftIcon?: boolean;
  withRightIcon?: boolean;
};

const ListItemLoader = ({
  contentContainerStyle,
  leftSize = 24,
  rightSize = 24,
  spacing,
  textSize = 24,
  withLeftIcon,
  withRightIcon,
}: Props) => (
  <View
    style={[
      themeStyle.flex1,
      themeStyle.flexDirectionRowCenter,
      StyleSheet.flatten(contentContainerStyle),
    ]}
  >
    {withLeftIcon && (
      <View
        style={
          spacing ? { marginRight: spacing } : themeStyle.spacingRightMedium
        }
      >
        <RectangleLoader width={leftSize} height={leftSize} />
      </View>
    )}
    <View style={themeStyle.flex1}>
      <RectangleLoader width="100%" height={textSize} />
    </View>
    {withRightIcon && (
      <View
        style={spacing ? { marginLeft: spacing } : themeStyle.spacingLeftMedium}
      >
        <RectangleLoader width={rightSize} height={rightSize} />
      </View>
    )}
  </View>
);

export default ListItemLoader;
